import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "good-loyalty-icon" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('lancelots.seoHeading')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "lancelots" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TopRolePlayer, {
          role: "goodLancelot",
          displayRole: true,
          class: "my-4"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TopRolePlayer, {
          role: "evilLancelot",
          displayRole: true,
          class: "my-4"
        })
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('lancelots.generalTipsTitle')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lancelots.embraceUnpredictabilityTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lancelots.embraceUnpredictabilityDescription')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lancelots.dualityOfRolesTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lancelots.dualityOfRolesDescription')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lancelots.observeAndAdaptTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lancelots.observeAndAdaptDescription')), 1)
      ])
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}